module.exports = __webpack_public_path__ + "static/img/200231.f24e1e08.png";